var render = function render(_c,_vm){return _c('div',[_c('v-icon',{staticClass:"current-color",style:('background-color:' + _vm.$options.methods.getColorCode(_vm.props.item.color)),attrs:{"align-center":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }